export const WLOST_001 = 'Modifier le mot de passe du compte d\'un proche';

export const WLOST_600 = 'Félicitations, le mot de passe créé pour le compte de votre proche est enregistré.';
export const WLOST_601 = 'Communiquez ce nouveau mot de passe à l\'utilisateur du compte et invitez-le à renseigner ses moyens de contact dans son espace client pour une gestion autonome de son mot de passe.';
export const WLOST_603 = 'Retour à la liste des comptes';